<template>
	<button type="button" :class="buttonClasses" @click="navigateBack">
		<font-awesome-icon :icon="['fas', 'chevron-left']" />
	</button>
</template>

<script>
	export default {
		name: 'BackButton',
		props: {
			from: {
				type: String,
				default () {
					return ""
				}
			},
			fixed: {
				type: Boolean,
				default () {
					return false
				}
			}
		},
		computed: {
			buttonClasses () {
				return {
					'button': true,
					'btn-back': true,
					'is-fixed': this.fixed
				}
			}
		},
		methods: {
			navigateBack () {
				if(this.from === null || this.$route.name === 'news'){
					this.$router.push('/cardinfo')
				} else {
					if (this.$route.name === 'my-card') {
						this.$router.push({ name: 'home' })
					} else {
						this.$router.go(-1)
					}
				}
			}
		}
	}
</script>

<style lang="scss">
	// style declared in global/_buttons.scss
	.btn-back {
		z-index: 1000;
	}
</style>